import React, { useCallback, useEffect, useState } from 'react';
import styles from './ProgramsPage.module.scss';
import clsx from 'clsx';
import { RigthArrowIcon } from '../Icons/index.js';
import { ProgramsDataType } from './ProgramsPage.type.js';
import { programsDummy } from '../_dummyData/programs.js';
import { ArrowDownIcon } from '../Icons/index.js';

export const ProgramsPage: React.FC = React.memo(() => {
  const [data, setData] = useState<ProgramsDataType[]>([]);
  const [activeKey, setActiveKey] = useState<number | null>(1);

  useEffect(() => {
    if (!data.length) {
      setData(programsDummy);
    }
  }, [data.length]);

  const toggleList = useCallback(
    (key: number | null) => {
      if (activeKey === key) {
        setActiveKey(null);
      } else {
        setActiveKey(key);
      }
    },
    [activeKey],
  );
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Программные модули</h1>
        <div className={styles.wrapper}>
          {data.map((item, key) => (
            <div
              key={`${item.title}-${key}`}
              className={clsx(styles.item, activeKey === key && styles.active)}
            >
              <div className={styles.itemTitle} onClick={() => toggleList(key)}>
                <ArrowDownIcon className={styles.icon} />
                {item.title}
              </div>
              {activeKey === key && (
                <div className={styles.itemHidden}>
                  {item.lists.map((list, listKey) => {
                    const isLastList = item.lists.length - 1 === listKey;
                    return (
                      <div
                        key={`${list.title}-${listKey}`}
                        className={styles.itemRowBlock}
                      >
                        <div className={styles.itemRowTitle}>{list.title}</div>
                        {!!list.rows?.length && (
                          <ul className={styles.itemRowUList}>
                            {list.rows.map((row, rowKey) => (
                              <li
                                key={`nonlist:${list.title}-${listKey}-${rowKey}`}
                                className={styles.itemRow}
                              >
                                {row}
                              </li>
                            ))}
                          </ul>
                        )}
                        {!!list.listRows?.length && (
                          <ul>
                            {list.listRows?.map((row, rowKey) => {
                              const isLastListItem =
                                Number(list.listRows?.length) - 1 === rowKey;
                              return (
                                <li
                                  key={`${list.title}-${listKey}-${rowKey}`}
                                  className={styles.itemListRow}
                                >
                                  {isLastList && isLastListItem ? (
                                    <p>
                                      По вопросам приобретения права
                                      использования исходного кода программного
                                      модуля Вы можете обратиться на{' '}
                                      <a
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        href="mailto:info@praktis.ru"
                                      >
                                        info@praktis.ru
                                      </a>
                                    </p>
                                  ) : (
                                    row
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                        {activeKey === 2 && listKey === 0 && (
                          <p>
                            Это, прежде всего, относится к взаимодействию с{' '}
                            <a
                              // className={styles.itemLink}
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://zakupki.gov.ru/epz/main/public/home.html"
                            >
                              «Главным порталом закупок»
                            </a>
                          </p>
                        )}
                      </div>
                    );
                  })}
                  {item.links.length > 0 && (
                    <div className={styles.itemLinks}>
                      {item.links.map((link) => (
                        <a
                          href={link.url}
                          download
                          key={link.url}
                          className={styles.itemLink}
                        >
                          {link.name ? link.name : link.url}
                          <RigthArrowIcon />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
